import { TBusinessUser } from "@elixir/types";
import { TrystGenericResponse } from "../types/tryst";
import { GET_TRYST_HOST } from "../constants/env";

export default async function getAllBusinessUsers({
  since,
}: {
  since?: string;
}): Promise<
  TrystGenericResponse<{ users: TBusinessUser[]; time_cursor?: string }>
> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    if (since) {
      myHeaders.append("if-modified-since", since);
    }

    const requestOptions: RequestInit = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      credentials: "include",
      mode: "cors",
    };

    const response = await fetch(
      `${TRYST_HOST}/business/users`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
